module.exports = "/_next/static/images/city-am-badge-cda84e321cae1786ac13a12b9f74d0d0.jpg";